// Data-only wire validation deliberately does not require the recipient's catalog.
// Recipients must still apply their code-owned command execution policy.
const id = value => typeof value === 'string' && /^[a-z0-9][a-z0-9._:-]{0,95}$/.test(value)
const object = value => value && typeof value === 'object' && !Array.isArray(value)
const keys = (value, allowed) => object(value) && Object.keys(value).every(key => allowed.includes(key))
const unique = values => new Set(values).size === values.length
export function validSharedCommandDocument(value) {
  if (!keys(value, ['bindings']) || !Array.isArray(value.bindings)) return false
  if (value.bindings.length > 512 || new TextEncoder().encode(JSON.stringify(value)).length > 262144) return false
  if (!unique(value.bindings.map(row => row?.id))) return false
  const replacements = value.bindings.map(row => row?.replacesDefaultBindingId).filter(Boolean)
  if (!unique(replacements)) return false
  return value.bindings.every(row => keys(row, ['id', 'commandId', 'sequence', 'platform', 'schemaVersion', 'enabled', 'replacesDefaultBindingId'])
    && id(row.id) && id(row.commandId) && row.schemaVersion === 1 && typeof row.enabled === 'boolean'
    && ['all', 'mac', 'windows', 'linux'].includes(row.platform)
    && (row.replacesDefaultBindingId == null || (id(row.replacesDefaultBindingId) && row.replacesDefaultBindingId.startsWith('default.')))
    && Array.isArray(row.sequence) && row.sequence.length >= 1 && row.sequence.length <= 5
    && row.sequence.every(stroke => keys(stroke, ['key', 'modifiers']) && typeof stroke.key === 'string' && stroke.key.length > 0 && stroke.key.length <= 40
      && !/[\u0000-\u001f\u007f]/.test(stroke.key) && Array.isArray(stroke.modifiers) && unique(stroke.modifiers)
      && stroke.modifiers.every(modifier => ['Mod', 'Control', 'Meta', 'Alt', 'Shift'].includes(modifier))))

}

// Older browser exports contain macros. Extract only shortcut preferences;
// keep the original export intact and never put macro definitions on this wire.
export function sharedDocumentFromExport(value) {
  if (validSharedCommandDocument(value)) return value
  if (keys(value, ['schemaVersion', 'bindings', 'macros']) && (value.schemaVersion == null || value.schemaVersion === 1)) {
    const document = { bindings: value.bindings }
    return validSharedCommandDocument(document) ? document : null
  }
  return null
}
